import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './index';

type ProviderProps = {
	children: React.ReactNode;
};

export const ProviderRedux: React.FC<ProviderProps> = ({ children }) => {
	return <ReduxProvider store={store}>{children}</ReduxProvider>;
};
